import type { JSX } from 'react';
import { Banner, Box, Button } from '@primerai/thread';
import { Redirect, useSearch } from 'wouter';
import { LoginWrapper } from '../Login/LoginWrapper';
import { useLogout } from './helpers';
import { INTERSTITIAL, withBranding } from '~/components/branding';
import Loading from '~/components/loading';
import { LOGIN, LOGOUT } from '~/routes/paths';

const LogoutPage = (): JSX.Element => {
  const search = useSearch();
  const searchParams = search ? `?${search}` : '';

  const { loading, error } = useLogout();

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return withBranding(INTERSTITIAL)(() => (
      <LoginWrapper>
        <Box width="100%">
          <Banner intent="danger" message="Unable to log out" />
        </Box>
        <Button
          appearance="primary"
          onClick={() => (window.location.href = `${LOGOUT}${searchParams}`)}
        >
          Try again
        </Button>
      </LoginWrapper>
    ))({});
  }

  return <Redirect state={{ logout: true }} to={`${LOGIN}${searchParams}`} />;
};

export default LogoutPage;
